const CompanyInfoContent = ({ ...props }) => {
  return (
    <>
      <div className="content-row">
        HDFC Life Insurance Company Limited (“HDFC Life”). CIN:
        L65110MH2000PLC128245, IRDAI Reg. No. 101
      </div>
      <div className="content-row">
        Registered Office: LodhaExcelus, 13th Floor, Apollo Mills Compound, N.M.
        Joshi Marg,Mahalaxmi, Mumbai 400 011. Email:
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:service@hdfclife.com"
        >
          service@hdfclife.com
        </a>
        ,Tel. No:{" "}
        <a target="_blank" rel="noopener noreferrer" href="tel:1860 267 9999">
          1860 267 9999
        </a>
        (Mon-Sat 10 AM to 7 PM) Local charges apply. Do NOT prefix any country
        code. e.g. +91 or 00. Website: www.hdfclife.com
      </div>
      <div className="content-row">
        The name/letters 'HDFC' in the name/logo of HDFC Life Insurance Company
        Limited (HDFC Life) belongs to HDFC Bank Limited and is used by HDFC
        Life under license from HDFC Bank Limited.
      </div>
    </>
  );
};
const CompanyInfoContentForLeadCapture = ({ ...props }) => {
  return (
    <>
      <div className="content-row">
      HDFC Life Insurance Company Limited ("HDFC Life"). CIN: L65110MH2000PLC128245, IRDAI Registration No. 101. 
      </div>
      <div className="content-row">
      Registered Office: 13th Floor, Lodha Excelus, Apollo Mills Compound, N.M. Joshi Marg, Mahalaxmi, Mumbai 400 011. Email: 
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:service@hdfclife.com"
        >
          service@hdfclife.com
        </a>
        ,Tel. No:{" "}
        <a target="_blank" rel="noopener noreferrer" href="tel:1860 267 9999">
        022-6844-6530 
        </a>
        (Call charges apply). Website: www.hdfclife.com
      </div>
      <div className="content-row">
      The name/letter ‘HDFC’ in the name/logo of HDFC Life Insurance Company Limited (HDFC Life) belongs to HDFC Bank Limited and is used by HDFC Life under licence from HDFC Bank Limited.
      </div>
    </>
  );
};
export const C2PL_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Click 2 Protect Life (UIN: 101N139V07)</b> is a A
        Non-Linked, Non-Participating, Individual, Pure Risk Premium/ Savings
        Life Insurance Plan. Life Insurance Coverage is available in this
        product. For more details on risk factors, associated terms and
        conditions and exclusions please read sales brochure carefully before
        concluding a sale. ARN: AD/10/21/26075
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const C2PSN_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Click 2 Protect Supreme (UIN: 101N183V01)</b> is a
        Non-Linked, Non-Participating, Individual, Pure Risk Premium/ Savings
        Life Insurance Plan. Life Insurance Coverage is available in this
        product. This version of the product brochure invalidates all previous
        printed versions for this particular plan. This Product brochure is
        indicative of the terms, warranties, conditions and exclusions contained
        in the insurance policy. Please know the associated risk and applicable
        charges from your insurance agent or the intermediary or policy document
        of the insurer. HDFC Bank Limited is the Corporate Agent (IRDAI Reg. No.
        CA0010) of HDFC Life. Insurance policy is underwritten by HDFC Life.
        Purchase of Insurance policy is voluntary. ARN: MC/08/22/28562
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const C2A_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
        I/We declare that: i. I/We have replied to the questions, and have made
        the statements in respect of the matters sought for, in the proposal
        Form/Electronic proposal form ("Proposal Form") and I understand and
        agree that the replies given and statements/declarations made in the
        Proposal Form together with any documents submitted by me/us for
        processing my/our application for insurance shall be the basis of the
        contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Click 2 Achieve (UIN: 101N186V03)</b> is Non-linked
        Non-Participating Individual Life Insurance Savings Plan . Provided all
        due premiums have been paid and the policy in force  Flexibility to
        choose Death Benefit, Premium Payment Term, Policy Term, Benefit
        Structure as per structure chosen by customer  1 to 10% Simple Interest
        per annum, depending upon the increasing income percentage chosen.
        Applicable for Early income and income structure
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const C2APAR_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
        I/We declare that: i. I/We have replied to the questions, and have made
        the statements in respect of the matters sought for, in the proposal
        Form/Electronic proposal form ("Proposal Form") and I understand and
        agree that the replies given and statements/declarations made in the
        Proposal Form together with any documents submitted by me/us for
        processing my/our application for insurance shall be the basis of the
        contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Click 2 Achieve Par Advanatge (UIN: 101N207V01)</b> is Non-linked
        Non-Participating Individual Life Insurance Savings Plan . Provided all
        due premiums have been paid and the policy in force  Flexibility to
        choose Death Benefit, Premium Payment Term, Policy Term, Benefit
        Structure as per structure chosen by customer  1 to 10% Simple Interest
        per annum, depending upon the increasing income percentage chosen.
        Applicable for Early income and income structure
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const SJB_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Saral Jeevan Bima (UIN: 101N140V01)</b> is a non-linked,
        non-participating, individual, pure risk premium life insurance plan.
        Life Insurance Coverage is available in this product. ARN:
        AD/04/22/28490
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const Sanchay_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Sanchay (Form no. P501-118 UIN: 101N097V12)</b> is A
        Non-Linked, Non-Participating, Life Insurance Plan. Life Insurance
        Coverage is available in this product. For more details on risk factors,
        associated terms and conditions and exclusions please read sales
        brochure carefully before concluding a sale. ARN: AD/10/21/26075
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};
export const SanchayPlus_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Sanchay Plus (UIN No: 101N134V24)</b> is a
        non-participating, non-linked savings insurance plan. Life Insurance
        Coverage is available in this product. For more details on risk factors,
        associated terms and conditions and exclusions, please read the sales
        brochure carefully before concluding a sale. ARN: AD/10/21/26075
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};
export const SanchayPar_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Sanchay Par Advantage (UIN:101N136V04)</b> is a Non-Linked,
        Participating Life Insurance Plan. Life Insurance Coverage is available
        in this product. For more details on risk factors, associated terms and
        conditions and exclusions, please read the sales brochure carefully
        before concluding a sale. ARN: AD/10/21/26075
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const GIIP_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Guaranteed Income Insurance Plan (UIN: 101N146V04)</b> is A
        Non-Linked Non-Participating Individual Life Insurance Savings Plan.
        This version of the product brochure invalidates all previous printed
        versions for this particular plan. Please know the associated risk and
        applicable charges from your insurance agent or the intermediary or
        policy document of the insurer. HDFC Bank Limited is the Corporate Agent
        (IRDAI Reg. No. CA0010) of HDFC Life. Insurance policy is underwritten
        by HDFC Life. Purchase of Insurance policy is voluntary
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const SaralJeevan_Disclaimer = ({ props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Saral Jeevan UIN: 101N160V02.</b> is a non-Linked
        Non-Participating Individual Life cum Savings Insurance Plan. Life
        Insurance Coverage is available in this product. Please know the
        associated risk and applicable charges from your insurance agent or the
        intermediary or policy document of the insurer. HDFC Life Protect Plus
        Rider (UIN:101B016V01) is a Non-Linked Health Insurance Rider. HDFC Life
        Income Benefit on Accidental Disability Rider (UIN: 101B013V03, Form
        No.: R501-21-01) is a Non-Linked, Non-Participating Rider. HDFC Life
        Critical Illness Plus Rider (UIN: 101B014V02, Form No: R501-23-01) is a
        non-linked, non-participating rider. HDFC Bank Limited is the Corporate
        Agent (IRDAI Reg. No. CA0010) of HDFC Life. Insurance policy is
        underwritten by HDFC Life. Purchase of Insurance policy is voluntary
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const SMPP_Disclaimer = ({ props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>DFC Life Smart Pension Plus (UIN: 101N173V10) </b> is a non-Linked
        Non-Participating Individual Life cum Savings Insurance Plan. Life
        Insurance Coverage is available in this product. Please know the
        associated risk and applicable charges from your insurance agent or the
        intermediary or policy document of the insurer. HDFC Life Protect Plus
        Rider (UIN:101B016V01) is a Non-Linked Health Insurance Rider. HDFC Life
        Income Benefit on Accidental Disability Rider (UIN: 101B013V03, Form
        No.: R501-21-01) is a Non-Linked, Non-Participating Rider. HDFC Life
        Critical Illness Plus Rider (UIN: 101B014V02, Form No: R501-23-01) is a
        non-linked, non-participating rider. HDFC Bank Limited is the Corporate
        Agent (IRDAI Reg. No. CA0010) of HDFC Life. Insurance policy is
        underwritten by HDFC Life. Purchase of Insurance policy is voluntary
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const SAGA_Disclaimer = ({ props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
            I/We declare that: i. I/We have replied to the questions, and have
        made the statements in respect of the matters sought for, in the
        proposal Form/Electronic proposal form ("Proposal Form") and I
        understand and agree that the replies given and statements/declarations
        made in the Proposal Form together with any documents submitted by me/us
        for processing my/our application for insurance shall be the basis of
        the contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>DFC Life Smart Pension Plus (UIN: 101N173V10) </b> is a non-Linked
        Non-Participating Individual Life cum Savings Insurance Plan. Life
        Insurance Coverage is available in this product. Please know the
        associated risk and applicable charges from your insurance agent or the
        intermediary or policy document of the insurer. HDFC Life Protect Plus
        Rider (UIN:101B016V01) is a Non-Linked Health Insurance Rider. HDFC Life
        Income Benefit on Accidental Disability Rider (UIN: 101B013V03, Form
        No.: R501-21-01) is a Non-Linked, Non-Participating Rider. HDFC Life
        Critical Illness Plus Rider (UIN: 101B014V02, Form No: R501-23-01) is a
        non-linked, non-participating rider. HDFC Bank Limited is the Corporate
        Agent (IRDAI Reg. No. CA0010) of HDFC Life. Insurance policy is
        underwritten by HDFC Life. Purchase of Insurance policy is voluntary
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const SANLP_Disclaimer = ({ ...props }) => {
  return (
    <div>
      <div className="content-row">
        <b>
          Declaration of the Life(s) to be Assured and Proposer / Policy Owner:
        </b>
        I/We declare that: i. I/We have replied to the questions, and have made
        the statements in respect of the matters sought for, in the proposal
        Form/Electronic proposal form ("Proposal Form") and I understand and
        agree that the replies given and statements/declarations made in the
        Proposal Form together with any documents submitted by me/us for
        processing my/our application for insurance shall be the basis of the
        contract between me/us and HDFC Life Insurance Company Limited ("the
        Company"). All documents submitted by me/us along with this Proposal
        Form are authentic, valid, and where relevant true copies of originals
        for the purpose of this Proposal Form have been submitted and I/ we have
        not withheld any material fact within my/ our knowledge. iii. I/We
        understand and agree that in case of misstatement and suppression of
        material facts the policy contract shall be treated in accordance with
        the Sec 45 of Insurance Act, 1938 as amended from time to time. iv. I/We
        shall be bound to notify the Company forthwith, in writing, of any
        change in my/our health, occupation or income between the date of this
        Proposal Form and the date of acceptance of my/our proposal for
        insurance, as communicated in writing to me/us by the Company. v. I/We
        have deposited the first premium along with this Proposal Form, and the
        premiums payable under the Policy that may be issued in pursuance of
        this proposal for insurance, will be paid, strictly in accordance with
        the law of the land. Amounts paid, otherwise than from my account shall
        be paid only if i/we can establish an insurable interest. vi. All/any
        amounts paid/payable towards the policy will be out of legally declared
        and assessed sources. Further, all the premiums will be paid in
        accordance with Prevention of Money Laundering Act 2002 (as amended from
        time to time) or any other applicable laws. vii. I/we will provide
        information as required by the Company, on its own or under any lawful
        instruction/ order, regarding sources of funds/utilization/ withdrawals.
      </div>
      <div className="content-row">
        I/We agree and understand: i. That the Company will be on risk in
        pursuance of this proposal for insurance only after the risk under the
        Proposal Form is accepted by the Company and such acceptance is
        communicated to me/us in writing by the Company. ii. That the Company
        has the right either to accept or reject my/ our proposal without giving
        reasons thereto and I undertake that there shall be no costs, claims,
        charges being raised by me/ us against the Company thereof. iii. That
        the Company shall be entitled to retain the premium paid along with the
        Proposal Form as an interest free initial deposit to be adjusted against
        premium payable upon issuance of the Policy. In the event the proposal
        for insurance is not accepted by the Company the aforesaid deposit shall
        be refunded without any interest subject to deductions for medical
        costs, if any. iv. That the premium payable as well as the sum assured
        (main as well as additional benefits) may vary upon assessment of risk
        by the Company. v. That the Company may seek information from any of my/
        our past or present employers/ business associates or from a
        doctor/medical examiner / hospital / laboratory / clinic who at any time
        have attended to me/ us concerning anything which affects my/ our
        physical or mental health or may seek information from any insurance
        office to which an application has been made for insurance on my/ our
        life. I/ We hereby authorize such parties to furnish information as
        required by the Company and also to furnish any documents regarding my/
        our employment/business, my/ our health and habits or health and habits
        of the Life to be Assured (without taking the prior consent of my/ our
        family or of any member thereof) as it may require either for the
        purpose of processing my/ our proposal for insurance or at any time
        thereafter for any other purpose in relation to the Policy that may be
        issued in pursuance of this proposal for insurance vi. In the event of
        I/we being medically examined, the answers given by me/ us to the
        medical examiner acting on behalf of the Company shall be deemed to be
        incorporated in this proposal for insurance. vii. That the Company may,
        without any reference to me/us or my family or any member thereof,
        furnish any details/ information furnished in this Proposal Form to any
        judicial or statutory or other authority or to any insurer or reinsurer
        in connection with the processing of this proposal for insurance or for
        servicing of this policy. viii. That in addition to postal or courier
        service, the Company may, at its discretion use any electronic media /
        registered email id, for communicating with me/us. ix. I hereby declare
        and agree that the above disclosures along with the Statements and the
        declarations made under the proposal made by me as Proposer and on
        behalf of the other/secondary life assured in case of joint life
        proposals will be the basis of the contract of assurance between us and
        HDFC Life. If any statement is found to be untrue or inaccurate or if
        any fact that might influence the terms of acceptance of this proposal
        is not disclosed by me in my capacity as Proposer and on behalf of the
        other/secondary life assured in case of joint life proposals, the
        contract shall be treated in accordance with the Sec 45 of Insurance
        Act,1938 as amended from time to time. x. That I/We have voluntarily
        given my/our consent to collect, process, receive, possess, store, deal
        or handle my/our sensitive personal data or information [as defined in
        the Information Technology (Reasonable security practices and procedures
        and sensitive personal data or information) Rules 2011 as amended from
        time to time],with third parties/ vendors associated with the Company
        for various purposes and outsourced activities related to
        issuance/servicing/settlement of claim as required under the Policy.
      </div>
      <div className="content-row">
        Additional Declaration (Applicable for Health Rider / Product): i. I/We
        hereby declare, on my/our behalf and on behalf of all persons proposed
        to be insured, that the above statements, answers and/or particulars
        given by me/us are true and complete in all respects to the best of my/
        our knowledge and that I/ We am/are authorised to propose on behalf of
        these other persons. ii. I/We understand that the information provided
        by me / us will form the basis of the insurance policy, is subject to
        the Board approved underwriting policy of the insurer and that the
        policy will come into force only after full payment of the premium
        chargeable. iii. I/We further declare that I / We will notify in writing
        any change occurring in the occupation or general health of the life to
        be insured/proposer after the proposal has been submitted but before
        communication of the risk acceptance by the company. iv. I/We declare
        that I/We consent to the company seeking medical information from any
        doctor or hospital who/which at any time has attended on the person to
        be insured/proposer or from any past or present employer concerning
        anything which affects the physical or mental health of the person to be
        insured/proposer and seeking information from any insurer to whom an
        application for insurance on the person to be insured /proposer has been
        made for the purpose of underwriting the proposal and/or claim
        settlement. v. I/We authorize the company to share information
        pertaining to my/our proposal including the medical records of the
        insured/proposer for the sole purpose of underwriting the proposal
        and/or claims settlement and with any Governmental and/or Regulatory
        authority.
      </div>
      <div className="content-row">
        <b>Section 41 –</b> Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45 –</b> 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Sanchay Legacy (UIN: 101N177V04)</b> A non-linked, non-participating individual life insurance plan that provides Guaranteed Death Benefit during the term of the policy.
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </div>
  );
};

export const OpenMarket_Disclaimer = ({ ...props }) => {
  return (
    <>
      <div className="content-row">
        <b>Section 41</b> – Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45</b> – 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <div className="content-row">
          <b>HDFC Life Click to Achieve (UIN:101N186V03)</b> is a Non-Linked,
          Non-Participating, Individual Savings Life Insurance Plan.
        </div>
        <b>HDFC Life Click 2 Protect Life (UIN: 101N139V07)</b> is a A
        Non-Linked, Non-Participating, Individual, Pure Risk Premium/ Savings
        Life Insurance Plan. Life Insurance Coverage is available in this
        product. For more details on risk factors, associated terms and
        conditions and exclusions please read sales brochure carefully before
        concluding a sale. ARN: AD/10/21/26075
      </div>

      {/* <div className="content-row">
        <b>HDFC Life Sanchay (Form no. P501-118 UIN: 101N097V12)</b> is A
        Non-Linked, Non-Participating, Life Insurance Plan. For more details on
        risk factors, associated terms and conditions and exclusions please read
        sales brochure carefully before concluding a sale. ARN: AD/10/21/26075
      </div> */}

      <div className="content-row">
        <b>HDFC Life Sanchay Par Advantage (UIN:101N136V03)</b> is a Non-Linked,
        Participating Life Insurance Plan.
      </div>

      <div className="content-row">
        <b>HDFC Life Sanchay Plus (UIN: 101N134V09)</b> is a non-participating,
        non-linked savings insurance plan.
      </div>
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </>
  );
};

export const OpenMarket_Disclaimer_C2PSN = ({ ...props }) => {
  return (
    <>
      <div className="content-row">
        <b>Section 41</b> – Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45</b> – 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />

      <div className="content-row">
        <b>HDFC Life Click 2 Protect Supreme(UIN:101N183V01)</b> is a A
        Non-Linked, Non-Participating, Individual, Pure Risk Premium/ Savings
        Life Insurance Plan. Life Insurance Coverage is available in this
        product. For more details on risk factors, associated terms and
        conditions and exclusions please read sales brochure carefully before
        concluding a sale. ARN: AD/10/21/26075.
      </div>

     
      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </>
  );
};


export const LeadCapture_Disclaimer = ({ ...props }) => {
  return (
    <>
      <CompanyInfoContentForLeadCapture />
      <div className="content-row">
        For more details on risk factors, associated terms and conditions and
        exclusions, please read the sales brochure carefully before concluding a
        sale. Unsubscribe if you no longer want to receive emails from us,
        simply reply to this email with the word “unsubscribe” in the subject
        line. HDFC Bank Limited is the Corporate Agent (IRDAI Reg. No. CA0010)
        of HDFC Life. Insurance policies are underwritten by HDFC Life. Purchase
        of Insurance policy is voluntary. ARN: MC/07/25/25008
      </div>

      {/* <div className="content-row">
        <b>HDFC Life Sanchay (Form no. P501-118 UIN: 101N097V12)</b> is A
        Non-Linked, Non-Participating, Life Insurance Plan. For more details on
        risk factors, associated terms and conditions and exclusions please read
        sales brochure carefully before concluding a sale. ARN: AD/10/21/26075
      </div> */}

  <div className="content-row">
        <b>HDFC Life Click 2 Protect Supreme(UIN:101N183V01)</b> is a A
        Non-Linked, Non-Participating, Individual, Pure Risk Premium/ Savings
        Life Insurance Plan. Life Insurance Coverage is available in this
        product. For more details on risk factors, associated terms and
        conditions and exclusions please read sales brochure carefully before
        concluding a sale. ARN: AD/10/21/26075.
      </div>

      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI or its officials do not involve in any activities of insurance
        business like selling insurance policies, announcing bonus or investment
        of premiums, refund of amounts. Policyholders or the prospects receiving
        such phone calls are requested to lodge a police complaint.
      </div>
    </>
  );
};
export const OpenMarket_DisclaimerRTL = ({ ...props }) => {
  return (
    <>
      <div className="content-row">
        <b>Section 41</b> – Prohibition of rebates: (1) No person shall allow or
        offer to allow, either directly or indirectly, as an inducement to any
        person to take or renew or continue an insurance in respect of any kind
        of risk relating to lives or property in India, any rebate of the whole
        or part of the commission payable or any rebate of the premium shown on
        the policy, nor shall any person taking out or renewing or continuing a
        policy accept any rebate, except such rebate as may be allowed in
        accordance with the published prospectuses or tables of the insurer. (2)
        Any person making default in complying with the provisions of this
        section shall be liable for a penalty which may extend to ten lakh
        rupees.
      </div>
      <div className="content-row">
        <b>Section 45</b> – 1.No policy of life insurance shall be called in
        question on any ground whatsoever after the expiry of three years from
        the date of the policy, i.e., from the date of issuance of the policy or
        the date of commencement of risk or the date of revival of the policy or
        the date of the rider to the policy, whichever is later. 2. A policy of
        life insurance may be called in question at any time within three years
        from the date of issuance of the policy or the date of commencement of
        risk or the date of revival of the policy or the date of the rider to
        the policy, whichever is later, on the ground of fraud: Provided that
        the insurer shall have to communicate in writing to the insured or the
        legal representatives or nominees or assignees of the insured the
        grounds and materials on which such decision is based. 3.Notwithstanding
        anything contained in sub-section (2), no insurer shall repudiate a life
        insurance policy on the ground of fraud if the insured can prove that
        the mis-statement of or suppression of a material fact was true to the
        best of his knowledge and belief or that there was no deliberate
        intention to suppress the fact or that such mis-statement of or
        suppression of a material fact are within the knowledge of the insurer:
        Provided that in case of fraud, the onus of disproving lies upon the
        beneficiaries, in case the policyholder is not alive. 4.A policy of life
        insurance may be called in question at any time within three years from
        the date of issuance of the policy or the date of commencement of risk
        or the date of revival of the policy or the date of the rider to the
        policy, whichever is later, on the ground that any statement of or
        suppression of a fact material to the expectancy of the life of the
        insured was incorrectly made in the proposal or other document on the
        basis of which the policy was issued or revived or rider issued:
        Provided that the insurer shall have to communicate in writing to the
        insured or the legal representatives or nominees or assignees of the
        insured the grounds and materials on which such decision to repudiate
        the policy of life insurance is based: Provided further that in case of
        repudiation of the policy on the ground of misstatement or suppression
        of a material fact, and not on the ground of fraud, the premiums
        collected on the policy till the date of repudiation shall be paid to
        the insured or the legal representatives or nominees or assignees of the
        insured within a period of ninety days from the date of such
        repudiation. 5. Nothing in this section shall prevent the insurer from
        calling for proof of age at any time if he is entitled to do so, and no
        policy shall be deemed to be called in question merely because the terms
        of the policy are adjusted on subsequent proof that the age of the life
        insured was incorrectly stated in the proposal.
      </div>
      <CompanyInfoContent />
      <div className="content-row">
        <b>HDFC Life Click 2 Protect Life (UIN: 101N139V07)</b> is a A
        Non-Linked, Non-Participating, Individual, Pure Risk Premium/ Savings
        Life Insurance Plan. Life Insurance Coverage is available in this
        product. For more details on risk factors, associated terms and
        conditions and exclusions please read sales brochure carefully before
        concluding a sale. ARN: AD/10/21/26075
      </div>

      <div className="beware-of-phone-calls">
        <div className="disclaimer-header">
          {" "}
          BEWARE OF SPURIOUS PHONE CALLS AND FICTIOUS/FRADULENT OFFERS
        </div>
        IRDAI is not involved in activities like selling insurance policies,
        announcing bonus or investment of premiums. Public receiving such phone
        calls are requested to lodge a police complaint
      </div>
    </>
  );
};
